//FOR PRODUCT PAGE SOLD POUT FUNCTIONALITY
document.addEventListener('DOMContentLoaded', function () {
    const soldProduct = document.querySelector('[data-sold-out-product]');

    if (!soldProduct) return;

    // Get available values from data attributes
    const itemValues = soldProduct.dataset.item
        .split(',')
        .map(item => item.trim())
        .filter(Boolean);

    const hourValues = soldProduct.dataset.hours
        .split(',')
        .map(hour => hour.trim())
        .filter(Boolean);

    // Pick a random value
    function randomValue(arr) {
        return arr[Math.floor(Math.random() * arr.length)];
    }

    const randomItems = randomValue(itemValues);
    const randomHours = randomValue(hourValues);

    // Update the text
    const soldNumber = soldProduct.querySelector('[data-sold-out-number]');
    const soldHours = soldProduct.querySelector('[data-sold-out-hours]');

    if (soldNumber) soldNumber.textContent = randomItems;
    if (soldHours) soldHours.textContent = randomHours;

    // Optional: change "hour" / "hours"
    const hoursTextNode = soldHours?.parentNode;
    if (hoursTextNode) {
        const textNodes = Array.from(hoursTextNode.childNodes).filter(
            node => node.nodeType === Node.TEXT_NODE
        );

        textNodes.forEach(node => {
            node.textContent = randomHours === '1'
                ? node.textContent.replace('hours', 'hour')
                : node.textContent.replace('hour', 'hours');
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const viewingProduct = document.querySelector('.productView-ViewingProduct');

    if (!viewingProduct) return;

    const values = viewingProduct.dataset.customerView
        .split(',')
        .map(item => parseInt(item.trim(), 10))
        .filter(num => !isNaN(num));

    if (!values.length) return;

    // Pick a random number from the list
    const randomCount = values[Math.floor(Math.random() * values.length)];

    // Update the text
    const text = viewingProduct.querySelector('.text');
    if (text) {
        text.textContent = `${randomCount} customers are viewing this product`;
    }
});